import { render } from "./Shopmania.vue?vue&type=template&id=5941feb9&scoped=true"
import script from "./Shopmania.vue?vue&type=script&lang=js"
export * from "./Shopmania.vue?vue&type=script&lang=js"

import "./Shopmania.vue?vue&type=style&index=0&id=5941feb9&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5941feb9"]])

export default __exports__